import React, { memo, Fragment } from 'react'
import { useTheme } from '@material-ui/core'
import PropTypes from 'prop-types'
import { RESOLUTION_SIZES } from '@v4/constants/images'
import PageMetaData from '@v4/utils/data/PageMetaData'
import { useSectionIndex } from '@v4/components/common/SectionItem'
import useStyles from './Picture.styled'

const Picture = ({ className, src, alt, srcSet }) => {
	const theme = useTheme()
	const classes = useStyles()
	const sectionIndex = useSectionIndex()

	return (
		<picture className={classes.root}>
			{srcSet &&
				srcSet
					.map(({ key, url, value }) => {
						const media = key === 'none' ? 'all' : theme.breakpoints.down(key).replace('@media ', '')
						return (
							<Fragment key={key}>
								{RESOLUTION_SIZES.map(size => (
									<source
										key={size}
										media={PageMetaData.imageResolutionSizeFrom(media, size)}
										srcSet={PageMetaData.imageThumbUrlFrom(url, Math.round(value * size))}
									/>
								))}
								{key !== 'none' && (
									<source media={media} srcSet={PageMetaData.imageThumbUrlFrom(url, value)} />
								)}
							</Fragment>
						)
					})
					.reverse()}
			<img
				loading={sectionIndex > 0 ? 'lazy' : 'eager'}
				className={className}
				src={src && PageMetaData.imageThumbUrlFrom(src, srcSet?.[0]?.value)}
				alt={alt || ''}
				width="100%"
				height="100%"
			/>
		</picture>
	)
}

Picture.propTypes = {
	className: PropTypes.string,
	src: PropTypes.string,
	alt: PropTypes.string,
	srcSet: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'none']).isRequired,
			url: PropTypes.string.isRequired,
			value: PropTypes.number.isRequired,
		}),
	),
}

export default memo(Picture)
